module.exports = __webpack_public_path__ + "static/media/fd5.26492b1e.jpg";